var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTimesCircle = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 414.93 414.93",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 207.46,
    cy: 207.46,
    r: 202.46,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 10
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237,207.47l77.92-77.92a14,14,0,0,0,0-19.7L305.08,100a13.92,13.92,0,0,0-19.69,0h0l-77.92,77.92L129.55,100a13.93,13.93,0,0,0-19.7,0h0L100,109.85a13.93,13.93,0,0,0,0,19.7h0l77.92,77.92L100,285.39a13.92,13.92,0,0,0,0,19.69h0l9.84,9.85a14,14,0,0,0,19.7,0L207.47,237l77.92,77.92a13.94,13.94,0,0,0,19.69,0l9.85-9.85a13.94,13.94,0,0,0,0-19.69Z"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimesCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/times-circle.1b8d5683.svg";
export { ForwardRef as ReactComponent };